module.exports = __webpack_public_path__ + "img/bgHero.db881cd5.png";